import React from "react";
import AddProduct from "../components/AddProduct";
import ProductList from "../components/ProductList";

const HomePage = () => {
  return (
    <main className="py-16">
      <div className="productWrapper">
        <ProductList />
        <div>
          <AddProduct />
        </div>
      </div>
    </main>
  );
};

export default HomePage;
